export const cupBottomsHeroContent = {
  badge: 'Beverage Grade Solution',
  scriptTitle: 'Our Premium',
  mainTitleLines: ['Cup', 'Bottoms'],
  kicker: 'Heat Resistant & Leak-Proof Sealing',
  descriptions: [
    'Engineered for paper cup manufacturing, our cup bottom paper combines superior heat resistance with reliable leak prevention for hot and cold beverage applications.',
    'From high-speed cup forming lines to QSR and café supply chains, our paper preserves consistent GSM, tight seals, and dependable bulk performance nationwide.',
  ],
  features: [
    'Heat Resistant',
    'Leak Proof',
    'Form Stable',
    'Pan India Supply',
  ],
  imagePrimary: {
    src: '/images/products/Cup-Bottoms1 (1).png',
    alt: 'Cup bottom paper material',
  },
  imageSecondary: {
    src: '/images/products/Cup-Bottoms1 (2).png',
    alt: 'Paper cup bottom manufacturing',
  },
  stampLabel: 'Leak Proof',
};
